import React from "react";
import {useTranslation} from "react-i18next";
import {DatePicker} from "antd";
import locale from "antd/es/date-picker/locale/tr_TR";

const DateFilter = ({value, onChange, showLabel = true, allowClear = false}) => {
    const {t} = useTranslation();
    return (
        <React.Fragment>
            {showLabel && <h5>{t("fields.date", {ns: "common"})}</h5>}
            <DatePicker
                locale={locale}
                value={value}
                format={"DD.MM.YYYY"}
                allowClear={allowClear}
                onSelect={date => onChange(date)}
                onChange={allowClear ? date => onChange(date) : undefined}
            />
        </React.Fragment>
    );
};

export default DateFilter;
